import React from "react";
import Navbar from "../ui/navbar";

interface AuthShellProps {
  title: string;
  children: React.ReactNode;
}

/**
 * Page shell for the auth pages (sign-in, register).
 *
 * Renders the global Navbar so anonymous users can still reach the public
 * categories (Overview / Search / Reference / ...) while on the auth flow —
 * they shouldn't have to sign in just to learn what the site does. Then
 * centers a narrow card with the title and the form slot.
 *
 * Matches the deposit.tsx / Settings shell pattern — same Navbar wrapper
 * top strip + gray background body.
 */
const AuthShell: React.FC<AuthShellProps> = ({ title, children }) => (
  <>
    <div className="relative flex-shrink-0 w-full py-8 border-b border-1">
      <Navbar />
    </div>
    <div className="flex justify-center bg-gray-50 min-h-[calc(100vh-4rem)]">
      <div className="w-full max-w-md px-6 py-10">
        <div className="p-6 bg-white border border-gray-200 rounded-lg shadow-sm">
          <h2 className="mb-6 text-2xl font-bold text-gray-900">{title}</h2>
          {children}
        </div>
      </div>
    </div>
  </>
);

export default AuthShell;
